import { useCallback, useRef, useState } from 'react';
import { Button, Form, Input, Schema } from 'rsuite';
import TextField from '../../components/form/textfield';
import { showToast } from '../../utils/toast';
import { sendFeedback } from '../../core';
import TelegramLogo from '../../assets/icons/Telegram_logo.svg';
import EmailLogo from '../../assets/icons/mail_logo.svg';

const { StringType } = Schema.Types;
const model = Schema.Model({
  // first_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  second_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  third_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!')
});
export const Support = () => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});
  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }
    setLoading(true);
    try {
      const { status, data } = await sendFeedback({
        ...formValue,
        first_q: -1
      });
      if (status === 200) {
        console.log(data);
        showToast(data.message, 'success');
      } else {
        showToast('مشکلی پیش آمده!', 'error');
      }
    } catch (e) {
      showToast('مشکلی پیش آمده!', 'error');
      console.log(e);
    }
    console.log('submitted', formValue);
    setLoading(false);
    // return;
  }, [formError, formValue]);
  return (
    <div
      className="relative"
      style={{
        minHeight: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, .85) 100%)',
          height: '100%'
        }}
        className=" px-3 py-3 text-justify">
        <Form
          ref={formRef}
          onChange={setFormValue}
          onCheck={setFormError}
          formError={formError}
          model={model}
          onSubmit={handleSubmit}
          className="w-full pb-3">
          اگر در حین اجرای برنامه به مشکلی بر خوردید یا برنامه در اجرای خود دچار اشکال شد، مشکل را
          در کادر زیر توضیح دهید تا تیم توسعه به زودی برا رفع آن اقدام کند. با تشکر از شما کاربر
          عزیز که ما را در هرچه بهتر شدن این برنامه باری می کنید.
          <br />
          <div className="text-sm mt-4">
            <TextField
              accepter={Input}
              type="text"
              name="second_q"
              label="مشکل را در کادر زیر بنویسید"
              placeholder="توضیح مشکل..."
              dir="rtl"
            />
            <TextField
              accepter={Input}
              type="text"
              name="third_q"
              label="ایمیل/شماره تماس را در کادر زیر بنویسید"
              placeholder="ایمیل/شماره تماس"
              dir="rtl"
            />
          </div>
          <div className="flex justify-center">
            <Button
              appearance="primary"
              className=" mt-5 btn-outline"
              type="submit"
              loading={loading}>
              ارسال گزارش خطا
            </Button>
          </div>
          <br />
          <br />
          <div className="text-sm" style={{ textAlign: 'right' }}>
            <div>
              ارتباط مستقیم با ما:
              <br />
              <br />
              <div className="flex items-center">
                <img className="w-8 ml-2" src={TelegramLogo} alt="" />
                <div>
                  آیدی های تلگرام:{' '}
                  <a
                    dir="ltr"
                    className="mx-.5"
                    href="https://t.me/medme_support"
                    target="_blank"
                    rel="noreferrer">
                    @medme_support
                  </a>{' '}
                  و{' '}
                  <a
                    dir="ltr"
                    className="mx-.5"
                    href="https://t.me/medme_supportt"
                    target="_blank"
                    rel="noreferrer">
                    @medme_supportt
                  </a>
                </div>
              </div>
              <br />
              <div className="flex items-start">
                <img className="w-8 ml-2" src={TelegramLogo} alt="" />
                <div>
                  این پلتفرم تخصصی آماده انتشار ویدئو های آموزشی متخصصین عزیز در سراسر ایران می
                  باشد. در صورت تمایل به عمکاری می تئانید از طریق ای آی دی تلگرام در تماس باشید{' '}
                  <a
                    dir="ltr"
                    className="mx-.5"
                    href="https://t.me/Medmepro"
                    target="_blank"
                    rel="noreferrer">
                    @Medmepro
                  </a>
                </div>
              </div>
              <br />
              <div className="flex items-center">
                <img className="w-8 ml-2" src={EmailLogo} alt="" />
                <div>
                  ایمیل:{' '}
                  <a
                    dir="ltr"
                    className="mx-.5"
                    href="mailto:support@faraad.org"
                    target="_blank"
                    rel="noreferrer">
                    support@faraad.org
                  </a>
                </div>
              </div>
              <br />
              کافیست روی آی دی تلگرام یا ایمیل بالا کلیک کنید تا برنامه تلگرام یا ایمیل برای شما باز
              شود و با پشتیبانی ارتباط برقرار کنید.
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
